import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from "@angular/core";

import {
  ModalDismissReasons,
  NgbActiveModal,
  NgbModal,
  NgbModalOptions,
} from "@ng-bootstrap/ng-bootstrap";
import { EventFormCustomFormType } from "../../events-screen/event-page-models/event-form-custom-form-type";

@Component({
  selector: "generic-chart-modal-container",
  templateUrl: "./generic-chart-modal-container.component.html",
  styleUrls: ["./generic-chart-modal-container.component.scss"],
})
export class GenericChartModalContainerComponent implements OnInit {
  public static readonly modalOptions: NgbModalOptions = {
    backdropClass: "user-management-form-main-modal-container",
    backdrop: true,
    windowClass: "edit-user-window-class",
  };
  @Output("result") public modalResult: EventEmitter<any> =
    new EventEmitter<boolean>();
  public modalIdInput: string;
  public readonly EventFormCustomFormType = EventFormCustomFormType;

  constructor(
    private modalService: NgbModal,
    public activeModal: NgbActiveModal,
    private changeDetector: ChangeDetectorRef
  ) {}

  public _customEventType: "user" | "activityFields";

  @Input("customFormType")
  public set customEventType(value: "user" | "activityFields") {
    if (value && value !== this._customEventType) {
      this._customEventType = value;
    }
  }

  @Input("modalEventIdInput")
  public set modalEventIdInput(value: string) {
    if (value && value !== this.modalIdInput) {
      this.modalIdInput = value;
    }
  }

  public ngOnInit(): void {
    this.modalIdInput = this.modalIdInput || "new";
    this._customEventType = this._customEventType || "user";
  }

  public modalClose(result: string) {
    this.activeModal.close(result);
  }

  public modalActionsHandler($event: any) {
    if ($event === "close") {
      this.modalClose(null);
    }
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/charts/generic-chart-modal/generic-chart-modal-container.component.ts